import { CalendarContext } from '../../../../utils/context/contextFactory';
import { ActionFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState } from '../../controller';
import { IUser } from '@wix/native-components-infra/dist/src/types/types';
import {
  checkForPricingPlanError,
  getValidPurchasedPricingPlansForService,
} from '../../../../utils/pricingPlans/pricingPlans';
import { AddError } from '../addError/addError';

export type OnUserLoggedIn = (user?: IUser) => void;

export function createOnUserLoggedInAction(
  {
    getControllerState,
    context: { calendarApi, experiments },
  }: ActionFactoryParams<CalendarState, CalendarContext>,
  addError: AddError,
): OnUserLoggedIn {
  return async (user) => {
    const [
      { availableServices, selectedTime, rescheduleBookingDetails },
      setState,
    ] = getControllerState();
    if (user) {
      setState({
        isUserLoggedIn: true,
      });
      const servicePricingPlans =
        (availableServices.length &&
          availableServices[0]?.payment.pricingPlanInfo?.pricingPlans!) ||
        [];
      const allPurchasedPricingPlans = user.loggedIn
        ? await calendarApi.getPurchasedPricingPlans({
            currentUser: user,
            service: availableServices?.[0],
          })
        : [];
      const purchasedPricingPlans = getValidPurchasedPricingPlansForService({
        allPurchasedPricingPlans,
        servicePricingPlans,
      });

      if (selectedTime) {
        const isRescheduleFlow = !!rescheduleBookingDetails;
        const pricingPlanError = checkForPricingPlanError({
          purchasedPricingPlans,
          isRescheduleFlow,
          selectedTime,
        });
        if (pricingPlanError) {
          addError(pricingPlanError);
        }
      }
      setState({
        purchasedPricingPlans,
      });
    }
  };
}
